import {Table} from "semantic-ui-react";
import {Link} from "react-router-dom";
import React from "react";

export function ItemListItems(props) {
    const items = props.items;

    const listItems = items.map((item) =>
        <Table.Row key={item.id}>
            <Table.Cell><Link to={`/items/${item.id}`}>{item.id}</Link></Table.Cell>
            <Table.Cell>{item.name}</Table.Cell>
            <Table.Cell>{item.status}</Table.Cell>
        </Table.Row>
    );

    return (
        <Table celled striped>
            <Table.Header>
                <Table.Row>
                    <Table.HeaderCell>ID</Table.HeaderCell>
                    <Table.HeaderCell>Name</Table.HeaderCell>
                    <Table.HeaderCell>Status</Table.HeaderCell>
                </Table.Row>
            </Table.Header>
            <Table.Body>{listItems}</Table.Body>
        </Table>
    )
}